import api from "./api";

// Los catalogos de un padre. Con texto, la busqueda de un autocomplete:
// filtra por la descripcion. Sin texto, el listado inicial (los primeros 50
// en orden alfabetico).
export const getCatalogosByPadre = async (idPadre, texto = "") => {
    const response = await api.get(
        `/Catalogo/GetCatalogosByIdPadreInLista?idPadre=${idPadre}&texto=${encodeURIComponent(texto || "")}`
    );

    return response.data.data;
}

export const GetCatalogoById = async (id) => {
    const response = await api.get(
        `/Catalogo/GetCatalogo?id=${id}`
    );

    return response.data.data;
}

// Catalogos padre (IdPadre = 0): alimentan el filtro de la busqueda y el campo
// padre del formulario.
export const getsCatalogoPadre = async () => {
    const response = await api.get("/Catalogo/GetsCatalogoPadre");

    return response.data.data;
}

export const getsCatalogoSearch = async (filters) => {
    const response = await api.get("/Catalogo/GetsCatalogoSearch", { params: filters });

    return response.data.data;
}

export const addUpdateCatalogo = async (catalogo) => {
    const response = await api.post("/Catalogo/AddUpdateCatalogo", catalogo);

    return response.data.data;
}
